import { render, staticRenderFns } from "./TermsRefund.vue?vue&type=template&id=3ef958df&scoped=true&"
import script from "./TermsRefund.vue?vue&type=script&lang=js&"
export * from "./TermsRefund.vue?vue&type=script&lang=js&"
import style0 from "./TermsRefund.vue?vue&type=style&index=0&id=3ef958df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef958df",
  null
  
)

export default component.exports